import mitt from 'mitt';

export enum UIReloadEmitter {
  Reload = 'Reload'
}

export const uiReloadEmitter = new mitt();
